/** MIME permitidos para upload de imagens de catálogo (Storage + formulários). */
export const ALLOWED_IMAGE_MIME_TYPES = [
  "image/jpeg",
  "image/jpg",
  "image/png",
  "image/gif",
  "image/webp",
] as const;

const EXT_TO_MIME: Record<string, (typeof ALLOWED_IMAGE_MIME_TYPES)[number]> = {
  jpg: "image/jpeg",
  jpeg: "image/jpeg",
  png: "image/png",
  gif: "image/gif",
  webp: "image/webp",
};

/**
 * Alguns ambientes (ex.: Windows / certos navegadores) deixam `File.type` vazio;
 * inferimos pelo sufixo do nome quando for extensão conhecida.
 */
export function resolveAllowedImageMimeType(file: File): string | null {
  if (file.type && (ALLOWED_IMAGE_MIME_TYPES as readonly string[]).includes(file.type)) {
    return file.type === "image/jpg" ? "image/jpeg" : file.type;
  }
  const ext = file.name.split(".").pop()?.toLowerCase() ?? "";
  const inferred = EXT_TO_MIME[ext];
  return inferred ?? null;
}
